export const DARK_COLOR = "#847057";
